import * as React from "react";
import { forwardRef } from "react";
const SvgToolZoom = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 22" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} transform="translate(1 1)"><ellipse cx={8.558} cy={8.091} rx={7.814} ry={7.636} /><path d="M14.419 13.818L20.279 19.545" /></g></svg>;
const ForwardRef = forwardRef(SvgToolZoom);
export { ForwardRef as ReactComponent };